import { IAppState } from '../../redux';

export const selectCurrency = (state: IAppState) => {
  const { offer } = state;

  return offer.bargainTerms.currency;
};
